<template>
  <div>

    
    <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="p-6">
            <SubHeader subHeaderTitle="Respuestas" />

            <v-row>
                <v-spacer class="col-xs-0">
                </v-spacer>
                <v-col cols="12" sm="12" md="6">
                    <v-btn
                        color=""
                        dark
                        class="mb-2 float-right bg-light-blue"
                        
                        @click="modalNuevaRespuesta"
                    >
                        Agregar Respuesta
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="cantidadOrdenEstados>0">
                <v-col cols="12">
                    <v-alert
                        text
                        prominent
                        type="error"
                        icon="mdi-alert"
                        dense
                        small
                        >
                            <p class="mt-3">Existen ({{cantidadOrdenEstados}}) respuestas activas sin un orden definido, por favor actualiza la información.</p> 
                        </v-alert>
                </v-col>
            </v-row>
            

            <v-data-table
                :items="respuestas"
                item-key="id"
                class="elevation-0 mt-4"
                :loading="tableLoading"
                no-data-text="No hay respuestas registradas para la pregunta"
                :items-per-page="10"
                dense
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right',
                    'items-per-page-text':'Registros por página',
                    pageText: '{0}-{1} de {2}' 
                }"
                :headers="respuestasHeaders"
            >
                <template v-slot:item="{ item }">
                   
                    <!-- @click="respuestasRowClick(item)"  -->
                    <tr  @click="respuestasRowClick(item)"  :class="{'selectedRow': item === selectedItem}" class="hoverRow" :style="item.estadosId===1 && item.noOrden===0 ? 'background: #ffe8ef !important;' : ''" >
                       <td> {{ item.noOrden }} </td>
                        <!--<td>
                            {{respuesta.id}}
                        </td>-->
                        <td>
                            {{item.textoRespuesta}}
                        </td>
                        <td>
                            {{item.nombreTipoDato}}
                        </td>
                        <td>
                            <v-chip
                                class="ma-2"
                                :color="item.estadosId === 1 ? 'teal' : item.estadosId ===2 ? 'red' : item.estadosId ===3 ? 'blue' : 'red' "
                                text-color="white"
                                small
                            >
                                {{item.estado}}
                            </v-chip>
                        </td>
                        <td>
                            <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="obtenerDatosRespuesta(item.id)">
                                <v-icon left>mdi-pencil</v-icon> Actualizar
                            </v-btn>
                        </td>
                    </tr>
                    
                </template>
            </v-data-table>
        </v-col>
        <v-col cols="1" md="1" sm="1" xs="0" class="d-flex justify-center">
            <v-divider
                vertical
            ></v-divider>
        </v-col>
        <v-col cols="12" md="12" sm="12" xs="12" class="p-6" v-if="respuestaSeleccionada>0">
            <SubHeader :subHeaderTitle="`Validaciones para ${textoRespuestaActual}`" />

            <v-row>
                <v-spacer class="col-xs-0">
                </v-spacer>
                <v-col cols="12" sm="12" md="6">
                    <v-btn
                        color=""
                        dark
                        class="mb-2 float-right bg-light-blue"
                        :disabled="validacionesDisponibles.length<=0"
                        @click="modalNuevaValidacion"
                    >
                        Agregar Validaci&oacute;n
                    </v-btn>
                </v-col>
            </v-row>

            <v-data-table
                :items="validacionesAsig"
                item-key="id"
                class="elevation-0 mt-4"
                :loading="tableLoadingValidaciones"
                no-data-text="No hay validaciones registradas para la respuesta"
                :items-per-page="10"
                dense
                :headers="validacionesHeaders"
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right',
                    'items-per-page-text':'Registros por página',
                    pageText: '{0}-{1} de {2}' 
                }"
        >
                <template v-slot:item="{ item }">
                    <tr>
                        <td>
                            {{item.id}}
                        </td>
                        <td>
                            {{item.nombre}}
                        </td>
                        <td>
                            {{item.validacionesId ===7 || item.validacionesId===8 ? `entre ${item.valorInicial} y ${item.valorFinal}` : 
                              item.validacionesId ===4 || item.validacionesId===5 || item.validacionesId ===12 || item.validacionesId===13 || item.validacionesId ===14 ? item.valorDefinido :
                              item.respuestaIdValorSeleccionado ? `Respuesta Pregunta ${item.respuestaIdValorSeleccionado}` : item.valorDefinido }}

                              {{item.respuestaIdValorSeleccionado ? 'Respuesta de una pregunta' : ''}}
                        </td>
                        <td>
                            <v-chip
                                class="ma-2"
                                :color="item.estadosId === 1 ? 'teal' : item.estadosId ===2 ? 'red' : item.estadosId ===3 ? 'blue' : 'red' "
                                text-color="white"
                                small
                            >
                                {{item.estado}}
                            </v-chip>
                        </td>
                        
                        <td>
                            <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="deshabilitarValidacion(item.id, item.estadosId ===1 ? 2 : 1, item.respuestasId)">
                                <v-icon left>{{item.estadosId===1 ? 'mdi-delete' : 'mdi-plus'}} </v-icon> {{item.estadosId===1 ? 'Deshabilitar' : 'Habilitar'}} 
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
    </v-row>


    <!--Inicio:: dialog para el registro de una respuesta-->
    <v-dialog
        v-model="dialogRes"
        max-width="900px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialogRes = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
                <v-form
                ref="form"
                v-on:submit.prevent="registrarRespuesta"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosRespuesta.textoRespuesta"
                                label="Texto de la respuesta"
                                :rules="[ required('Texto de la respuesta') ]"
                                maxlength="100"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosRespuesta.tipoDatoId"
                                :items="tiposDato"
                                class="required"
                                dense
                                outlined
                                :loading="ddTipoDatosLoading"
                                label="Tipo de dato para la respuesta"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Tipo de dato para la respuesta'
                                    )
                                ]"
                                @change="seleccionarTipoElemento"
                               
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row v-if="datosRespuesta.tipoDatoId===1 || datosRespuesta.tipoDatoId===2 || datosRespuesta.tipoDatoId===6">
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                    v-model="datosRespuesta.elementoSumatoria"
                                    :items="opcionesElementoSumatoria"
                                    class="required"
                                    dense
                                    outlined
                                    label="La respuesta es un elemento para realizar una sumatoria?"
                                    item-text="nombre"
                                    item-value="id"
                                    :rules="[ datosRespuesta.tipoDatoId===1 || datosRespuesta.tipoDatoId===2 || datosRespuesta.tipoDatoId===6 ? selectRequired('elemento sumatoria') : true
                                    ]"
                                
                                ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                :disabled="true"
                                v-model="datosRespuesta.tipoElementoId"
                                :items="tiposElemento"
                                class="required"
                                dense
                                outlined
                                :loading="ddTiposElementoLoading"
                                label="Tipo de control para la respuesta"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Tipo de control para la respuesta'
                                    )
                                ]"
                               
                            ></v-select>
                        </v-col>

                        <v-col v-if="tipoListas" cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosRespuesta.listasId"
                                :items="listas"
                                :class="tipoListas ? 'required' : true"
                                dense
                                outlined
                                :loading="ddTiposElementoLoading"
                                label="Seleccionar lista"
                                item-text="nombre"
                                item-value="id"
                                :rules="[  tipoListas ? selectRequired('Seleccionar lista ') : true ]"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                         <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosRespuesta.noOrden"
                                label="Número de orden"
                                :rules="[ 
                                    required('Número de orden'),
                                    maxNumber('Orden', 99),
                                    switchItemEstado== true ? minNumber('Orden', 0) : true
                                ]"
                                maxlength="2"
                                v-mask="'##'"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogRes = false; resetForm()"
                            :disabled="btnRegistroRespuestaLoading"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0" 
                            :disabled="!validForm" 
                            :loading="btnRegistroRespuestaLoading"                         
                        >
                            {{btnRegistroText}}
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <!--Fin:: dialog para el registro de una respuesta-->


    <!--Inicio:: dialog para el registro de una validacion-->
    <v-dialog
        v-model="dialogVal"
        max-width="900px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        <v-card scrollable>
            <v-card-title>
                {{modalValTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroValidacionLoading"
                    @click="dialogVal = false; resetValForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
                <v-form
                ref="form"
                v-on:submit.prevent="registrarValidacionRespuesta"
                v-model="validFormVal"
                >
                <v-card-text>
                    <v-row>

                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosValidacion.validacionesId"
                                :items="validacionesDisponibles"
                                class="required"
                                dense
                                outlined
                                :loading="ddTiposDatoLoading"
                                label="Tipo de validación para la respuesta"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Tipo de validación para la respuesta'
                                    )
                                ]"
                                @change="definirOrigenesValidacion"
                               
                            ></v-select>
                        </v-col>
                    </v-row>

                    <SubHeader v-if="datosValidacion.validacionesId==7 || datosValidacion.validacionesId==8" subHeaderTitle="Seleccionar valores para el rango" />


                    <!-- Mostrar que el origen de la respuesta sea de otra pregunta -->
                    <v-row v-if="datosValidacion.validacionesId==2 || datosValidacion.validacionesId==3 || datosValidacion.validacionesId==4 || datosValidacion.validacionesId==5 || datosValidacion.validacionesId==7 || datosValidacion.validacionesId==8
                                 || datosValidacion.validacionesId==9 || datosValidacion.validacionesId==10 || datosValidacion.validacionesId==11 || datosValidacion.validacionesId==12 || datosValidacion.validacionesId==13 || datosValidacion.validacionesId==14 || datosValidacion.validacionesId==15 || datosValidacion.validacionesId==16">
                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosValidacion.tipoValorInicial"
                                :items="origenesRespuesta"
                                class="required"
                                dense
                                outlined
                                :loading="ddTipoDatosLoading"
                                label="Seleccionar origen de la respuesta"
                                item-text="nombreOrigen"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Origen de la respuesta'
                                    )
                                ]"
                                @change="datosValidacion.tipoValorInicial===2 ? indiceSeleccionadoId=idIndice : null; datosValidacion.tipoValorInicial===2 ? obtenerPreguntasPorIndice() : null;"
                               
                            ></v-select>

                        </v-col>

                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field v-if="datosValidacion.tipoValorInicial===1"
                                outlined
                                autocomplete="off"
                                dense
                                v-model="valorInicialUsuario"
                                :label="datosValidacion.validacionesId===2 || datosValidacion.validacionesId===3 ? 'Escriba una fecha' :  
                                        datosValidacion.validacionesId===4 || datosValidacion.validacionesId===5 || datosValidacion.validacionesId==12 || datosValidacion.validacionesId==13 || datosValidacion.validacionesId==14 ? 'Escriba un número' : 
                                        datosValidacion.validacionesId===7 ? 'Escriba la fecha inicial' : 
                                        datosValidacion.validacionesId===8 ? 'Escriba el número menor' : ''"
                                maxlength="10"
                                :rules="[
                                    datosValidacion.validacionesId===2 || datosValidacion.validacionesId===3 || datosValidacion.validacionesId===7 ? dateFormat('Fecha') : true,
                                    datosValidacion.validacionesId===4 || datosValidacion.validacionesId===5 || datosValidacion.validacionesId===8 || datosValidacion.validacionesId==12 || datosValidacion.validacionesId==13 || datosValidacion.validacionesId==14 ? onlyInteger('Número') : true,
                                ]"
                                :v-mask="datosValidacion.validacionesId===2 || datosValidacion.validacionesId===3 || datosValidacion.validacionesId===7 ? '##/##/####': null"
                            ></v-text-field>

                            <!--<v-btn v-if="datosValidacion.tipoValorInicial===2"
                                color="blue-grey"
                                elevation="0"
                                class="mb-2 float-left white--text"
                                @click="mostrarValoresRespuestas"
                            >
                                Seleccionar valor de otra respuesta
                            </v-btn>-->
                        </v-col>
                    </v-row>

                    


                    <v-row v-if="datosValidacion.validacionesId==7 || datosValidacion.validacionesId==8">
                        <SubHeader subHeaderTitle="Seleccionar respuesta" />
                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosValidacion.tipoValorFinal"
                                :items="origenesRespuestaFinal"
                                class="required"
                                dense
                                outlined
                                :loading="ddTipoDatosLoading"
                                label="Seleccionar origen respuesta"
                                item-text="nombreOrigen"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Origen de la respuesta'
                                    )
                                ]"
                               
                            ></v-select>

                        </v-col>

                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1" v-if="datosValidacion.validacionesId==7 || datosValidacion.validacionesId==8">
                            <v-text-field v-if="datosValidacion.tipoValorInicial===1"
                                outlined
                                autocomplete="off"
                                dense
                                v-model="datosValidacion.valorFinal"
                                :label="datosValidacion.validacionesId===7 ? 'Escriba la fecha final' : 
                                        datosValidacion.validacionesId===8 ? 'Escriba el número mayor' : ''"
                                maxlength="10"
                                :rules="[
                                    datosValidacion.validacionesId===2 || datosValidacion.validacionesId===3 || datosValidacion.validacionesId===7 ? dateFormat('Fecha') : true,
                                    datosValidacion.validacionesId===4 || datosValidacion.validacionesId===5 || datosValidacion.validacionesId===8 ? onlyInteger('Número') : true,
                                ]"
                            ></v-text-field>

                            <v-btn v-if="datosValidacion.tipoValorInicial===2"
                                color="blue-grey"
                                elevation="0"
                                class="mb-2 float-left white--text"
                                @click="mostrarValoresRespuestas"
                            >
                                Seleccionar valor final
                            </v-btn>
                        </v-col>
                    </v-row>

                    <!-- Inicio::Mostrar el campo si la validacion es numero mayor que 3 o numero menor que 4 -->
                    <v-row v-if="datosValidacion.validacionesId==1">
                         <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                type="number"
                                dense
                                v-model="datosValidacion.valorDefinido"
                                label="Escriba la cantidad máxima de caracteres"
                                maxlength="3"
                                v-mask="'###'"
                                :rules="[onlyInteger('Caracteres'), maxLength('Cantidad caracteres', 3)]"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                     <!-- Fin:: Mostrar el campo si la validacion es numero mayor que 3 o numero menor que 4 -->


                     <!-- Inicio::Muestra el select de si/no en caso sea de tipo obligatoria la validacion -->
                    <v-row v-if="datosValidacion.validacionesId===6">
                         <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="opcionSiNoId"
                                :items="opcionesSiNo"
                                class="required"
                                dense
                                outlined
                                :loading="ddTipoDatosLoading"
                                label="Seleccionar"
                                item-text="nombre"
                                item-value="id"
                                :disabled="true"
                                :rules="[
                                    selectRequired(
                                        'Origen de la respuesta'
                                    )
                                ]"
                               
                            ></v-select>

                        </v-col>
                    </v-row>
                     <!-- Fin:: Muestra el select de si/no en caso sea de tipo obligatoria la validacion -->

                    <!--Inicio:: Mostrar indice, preguntas y respuestas para seleccionar en caso que el dato se seleccione de una respuesta-->
                    <v-row v-if="datosValidacion.tipoValorInicial===2">
                        
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="indiceSeleccionadoId"
                                :items="indices"
                                :loading="ddIndicesLoading"
                                dense
                                outlined
                                :rules="[datosValidacion.tipoValorInicial===2 ? required('Índice') : true]"
                                label="Seleccionar Índice"
                                item-text="nombreIndice"
                                item-value="id"
                                :disabled="true"
                                :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                                @change="obtenerPreguntasPorIndice()"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="preguntaSeleccionadaId"
                                :items="preguntas"
                                :loading="ddPreguntasLoading"
                                dense
                                outlined
                                :rules="[datosValidacion.tipoValorInicial===2 ? required('Índice') : true]"
                                label="Seleccionar Pregunta"
                                item-text="textoPregunta"
                                item-value="id"
                                :no-data-text="preguntas.length > 0 ? 'Selecciona una pregunta' : 'No se han encontrado preguntas para el índice seleccionado'"
                                @change="obtenerRespuestasPorPregunta(preguntaSeleccionadaId)"
                            ></v-select>
                        </v-col>


                                
                        
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosValidacion.respuestaIdValorSeleccionado"
                                :items="respuestasValidacion"
                                :loading="ddRespuestasLoading"
                                dense
                                outlined
                                :rules="[datosValidacion.tipoValorInicial===2 ? required('Índice') : true]"
                                label="Seleccionar Respuesta"
                                item-text="textoRespuesta"
                                item-value="id"
                                :no-data-text="respuestas.length ? 'Selecciona una respuestas' : 'No se encontraron respuestas para la pregunta seleccionada.'"
                            ></v-select>
                        </v-col>
                            
                       
                    </v-row>

                    <!--Fin:: Mostrar indice, preguntas y respuestas para seleccionar en caso que el dato se seleccione de una respuesta-->

                    
                     <!-- Inicio::Muestra el select de si/no en caso de que el tipo de validacion sea disponible solo si u obligatoria solo si -->
                    <v-row v-if="(datosValidacion.validacionesId===15 || datosValidacion.validacionesId===16) && datosValidacion.respuestaIdValorSeleccionado>0 ">
                         <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="opcionSiNoId"
                                :items="opcionesSiNo"
                                class="required"
                                dense
                                outlined
                                :loading="ddTipoDatosLoading"
                                label="Seleccionar"
                                item-text="nombre"
                                item-value="id"
                                :disabled="true"
                                :rules="[
                                    selectRequired(
                                        'Origen de la respuesta'
                                    )
                                ]"
                               
                            ></v-select>

                        </v-col>
                    </v-row>
                     <!-- Fin:: Muestra el select de si/no en caso de que el tipo de validacion sea disponible solo si u obligatoria solo si -->


                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogVal = false; resetValForm()"
                            :disabled="btnRegistroValidacionLoading"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0" 
                            :disabled="!validFormVal" 
                            :loading="btnRegistroValidacionLoading"                         
                        >
                            {{btnRegistroValidacionText}}
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <!--Fin:: dialog para el registro de una validacion-->


    <ValidacionPorRespuesta ref="validacionesPorRespuesta" />

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->

     <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderRespuestaVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->
  </div>
</template>

<script>
//import Draggable from 'vuedraggable';

import SubHeader from "@/view/components/subheader/SubHeader";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
import ValidacionPorRespuesta from "@/view/pages/admin/preguntas/respuestas/ValidacionPorRespuesta.vue";

import { OBTENER_RESPUESTAS, REGISTRAR_RESPUESTA, OBTENER_RESPUESTA, ACTUALIZAR_RESPUESTA, OBTENER_RESPUESTAS_PREGUNTA_TIPODATO } from "@/core/services/store/preguntas/respuestas/respuesta.module";
import { OBTENER_TIPOS_DATO } from "@/core/services/store/preguntas/respuestas/tiposdato/tipodato.module";
import { OBTENER_TIPOS_ELEMENTO } from "@/core/services/store/preguntas/respuestas/tiposelemento/tipoelemento.module";
import { OBTENER_LISTAS } from "@/core/services/store/catalogos/listas/lista.module";
import { OBTENER_VALIDACIONES_POR_RESPUESTA, OBTENER_VALIDACIONES, REGISTRAR_VALIDACION_RESPUESTA, ACTUALIZAR_ESTADO_VALIDACION_RESPUESTA } from "@/core/services/store/preguntas/validaciones/validacion.module";

import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_TODAS_PREGUNTAS_POR_INDICE } from "@/core/services/store/pregunta.module";


import validations from "@/core/untils/validations.js";
export default {
    name:"AdminRespuestas",
    props: ["idPregunta", "idIndice"],
    components: {
         SubHeader,
         SnackAlert,
         DialogLoader,
         ValidacionPorRespuesta,
         //Draggable
    },
    data: () => ({
        tableLoading:false,
        cantidadOrdenEstados:0,
        tableLoadingValidaciones: false,
        ddTiposDatoLoading:false,
        ddTiposElementoLoading:false,
        ddListasLoading: false,
        validForm:false,
        validFormVal:false,
        dialogLoaderRespuestaVisible:false,
        dialogLoaderText: 'Obteniendo información...',
        accion:1,
        accionVal: 1,
        opcionesElementoSumatoria: [{id: 2, nombre: 'NO'}, {id:1, nombre: 'SI'}],
        btnRegistroLoading:false,
        btnRegistroRespuestaLoading:false,
        btnRegistroText:'Registrar respuesta',
        modalTitle: 'Registrar respuesta',
        modalValTitle: 'Agregar validación',
        btnRegistroValidacion:false,
        btnRegistroValidacionLoading:false,
        btnRegistroValidacionText:'Agregar validación',
        dialogRes: false,
        dialogVal: false,
        ddTipoDatosLoading: false,
       // respuestas:[{id: 1, textoRespuesta: 'Hombres'}, {id: 2, textoRespuesta: 'Mujeres'}],
        respuestaSeleccionada:0,
        textoRespuestaActual:'',
        indiceSeleccionadoId:0,
        ddPreguntasLoading:false,
        ddRespuestasLoading:false,
        preguntaSeleccionadaId:0,
        validaciones:[{id: 1, nombreValidacion: 'Rango', valorDefinido: '1 a 20'}, {id: 2, nombreValidacion: 'Numero mayor que', valorDefinido: '0'}],
        validacionesDisponibles:[], //!Muestra las validaciones según el tipo de elemento de la respuesta
        validacionesAsig:[{id: 1, nombreValidacion: 'Rango', valorDefinido: '1 a 20'}, {id: 2, nombreValidacion: 'Numero mayor que', valorDefinido: '0'}],
        //tipoDatos: [{id: 1, nombreTipoDato: 'Número'}, {id: 2, nombreTipoDato: 'Texto'}, {id: 3, nombreTipoDato: 'Moneda'}, {id: 4, nombreTipoDato: 'Fecha'}, {id: 5, nombreTipoDato: 'Si/No'}, {id:5, nombreTipoDato: 'Decimal'}],
        tiposDato:[],
        tiposElemento:[],
        listas:[],
        indices:[],
        preguntas:[],
        respuestas:[],
        respuestasValidacion:[],
        tipoListas:false, //Se utiliza para habilitar / deshabilitar las listas para seleccionar en caso de que el tipo de dato sea (Elemento de una lista)
        origenesRespuesta:[{id:0, nombreOrigen:'Seleccionar'},{id: 1, nombreOrigen: 'Definido por el usuario'}, {id:2, nombreOrigen: 'Valor de otra respuesta'}],
        origenesRespuestaFinal: [{id:0, nombreOrigen:'Seleccionar'},{id: 1, nombreOrigen: 'Definido por el usuario'}, {id:2, nombreOrigen: 'Valor de otra respuesta'}],
        selectedItem: null,
        datosRespuesta:{
            textoRespuesta: '',
            preguntasId:0,
            tipoDatoId:0,
            //tipoRespuestaId: 0,
            noOrden:'0',
            tipoElementoId: 0,
            estadosId: 0,
            listasId: null,
            elementoSumatoria: 0
        },
        tipoDatoIdRespuestaSeleccionada:0,
        switchItemEstado: true,
        valorInicialUsuario:'',
        tipoValorInicial: 1, //1 es definido por el usuario, 2 es el id de otra respuesta
        tipoValorFinal: 1, //1 es definido por el usuario, 2 es el id de otra respuesta
        datosValidacion: {
            id:0,
            valorDefinido:'',
            validacionesId:0,
            respuestasId:0,
            rangosId:0,
            respuestaIdValorSeleccionado:0,
            valorInicial:'',
            valorFinal: '',
            respuestasIdValorInicial: 0,
            respuestasIdValorFinal: 0,
            tipoRespuestaId: 0,
        },
        ///Datos para las validaciones
        opcionesSiNo: [{id: 1, nombre: 'SI'}],
        opcionSiNoId: 1,
        ...validations
    }),
    methods: {
        resetForm(){
           // this.$refs.form.reset();
            
            this.datosRespuesta={
                textoRespuesta: '',
                preguntasId:0,
                tipoDatoId:0,
                noOrden:'0',
                //tipoRespuestaId: 0,
                tipoElementoId: 0,
                estadosId: 0,
                listasId: 0,
                elementoSumatoria:0
            };
            this.switchItemEstado = true;
            this.accion=1;
        },

        resetValForm(){
            this.datosValidacion = {
                id:0,
                valorDefinido:'',
                validacionesId:0,
                respuestasId:0,
                rangosId:0,
                respuestaIdValorSeleccionado:0,
                valorInicial:'',
                valorFinal: '',
                respuestasIdValorInicial: 0,
                respuestasIdValorFinal: 0,
                tipoValorInicial:0,
                tipoRespuestaId: 0,
            }
            this.preguntaSeleccionadaId=0;
        },

        //!Obtener las respuestas asignadas a la pregunta
        async obtenerRespuestasPregunta(){
            this.respuestas=[];
            //!Variable para acumular las respuestas que estan en estado activo y número de orden 0
            this.cantidadOrdenEstados=0;
            this.tableLoading=true;
            await 
            this.$store.dispatch(OBTENER_RESPUESTAS,{preguntasId: this.idPregunta})
            .then(response => {
                //console.log(response)
                if(response.status==200){
                    this.respuestas=response.data;

                    let cantidad=0;
                    this.respuestas.reduce(function (r, a) {
                       // console.log(a)

                        if(a.estadosId===1 && a.noOrden===0){
                            
                            r[a.estadosId] = (r[a.estadosId] || 0) + 1;
                            cantidad++;
                        }
                        
                        return r;
                    }, {});
                    this.cantidadOrdenEstados = cantidad;
                    //console.log(this.cantidadOrdenEstados)
                } else{
                    this.respuestas=[];
                }   
                this.tableLoading=false;
            })
            .catch(()=>{
                this.tableLoading=false;
            })
        },

        //!Obtener los tipos de dato para registrar la pregunta
        async obtenerTipoDatoPregunta(){
            this.ddTiposDatoLoading=true;
            this.tiposDato=[];
            await 
            this.$store.dispatch(OBTENER_TIPOS_DATO, 1)
            .then(response => {
                //console.log(response)
                if(response.status==200){
                    this.tiposDato=response.data;
                } else{
                    this.tiposDato=[];
                }   
                this.ddTiposDatoLoading=false;
            })
            .catch(err=>{
                console.log(err)
                this.ddTiposDatoLoading=false;
            })
        },

         //!Obtener los tipos de elemento para registrar la pregunta
        async obtenerTipoElementoPregunta(){
            this.ddTiposElementoLoading=true;
            this.tiposElemento=[];
            await 
            this.$store.dispatch(OBTENER_TIPOS_ELEMENTO, 1)
            .then(response => {
                //console.log(response)
                if(response.status==200){
                    this.tiposElemento=response.data;
                } else{
                    this.tiposElemento=[];
                }   
                this.ddTiposElementoLoading=false;
            })
            .catch(err=>{
                console.log(err)
                this.ddTiposElementoLoading=false;
            })
        },

        //!Obtener las listas en caso sea de tipo Dropdown
        async obtenerListasPregunta(){
            this.ddListasLoading=true;
            this.listas=[];
            await 
            this.$store.dispatch(OBTENER_LISTAS, 1)
            .then(response => {
                //console.log(response)
                if(response.status==200){

                    let listasM = response.data;
                    this.listas = listasM.filter(item => item.id !== 1);
                    

                    
                } else{
                    this.listas=[];
                }   
                this.ddListasLoading=false;
            })
            .catch(err=>{
                console.log(err)
                this.ddListasLoading=false;
            })
            
        },





        //!Registrar la respuesta para una pregunta
        async registrarRespuesta(){
            this.datosRespuesta.preguntasId = this.idPregunta;

            if(!this.tipoListas){
                delete this.datosRespuesta.listasId; 
            }

            //?Si es tipo 6 (Si / No), asignar la lista con id 1 (Si/No) de manera automática
            if(this.datosRespuesta.tipoDatoId===6){
                this.datosRespuesta.listasId===1;
            }

            //console.log(this.datosRespuesta)
            this.switchItemEstado ? this.datosRespuesta.estadosId = 1 : this.datosRespuesta.estadosId = 2;
            this.btnRegistroRespuestaLoading=true;
            if(this.accion===1){
                await this.$store
                    .dispatch(REGISTRAR_RESPUESTA, this.datosRespuesta)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerRespuestasPregunta();
                            this.dialogRes=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();                                
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroRespuestaLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroRespuestaLoading=false;
                    });
            } else {
                await this.$store
                    .dispatch(ACTUALIZAR_RESPUESTA, this.datosRespuesta)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerRespuestasPregunta();
                            this.dialogRes=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroRespuestaLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroRespuestaLoading=false;
                    });
            }
        },

        //!Obtener las validaciones para ser seleccionadas
        async obtenerValidaciones(){
            
            this.validaciones=[];
            this.tableLoadingValidaciones=true;
            await 
            this.$store.dispatch(OBTENER_VALIDACIONES,1)
            .then(response => {
               
                if(response.status==200){
                    this.validaciones=response.data;
                } else{
                    this.validaciones=[];
                }   
                // console.log(this.validaciones)
                this.tableLoadingValidaciones=false;
            })
            .catch(()=>{
                this.tableLoadingValidaciones=false;
            })
        },

        //!Obtener validaciones por respuesta
        async obtenerValidacionesRespuesta(IdRespuesta, tipoDatoId){
            this.validacionesAsig=[];
            this.tableLoadingValidaciones=true;
            await 
            this.$store.dispatch(OBTENER_VALIDACIONES_POR_RESPUESTA,{estadoId:0, respuestasId: IdRespuesta})
            .then(response => {
                //console.log(response)
                if(response.status==200){
                    this.validacionesAsig=response.data;
                } else{
                    this.validacionesAsig=[];
                }   

                /* Habilitar validaciones para el tipo de dato recibido */
                let arrFiltro=[];
                /**
                 * 1 Cantidad de Caracteres
                 * 2 Fecha anterior a
                 * 3 Fecha posterior a
                 * 4 Número Mayor que
                 * 5 Número Menor que
                 * 6 Obligatoria
                 * 7 Rango de fechas (Inactiva)
                 * 8 Rango Numérico (Inactiva)
                 * 9 Fecha Igual a
                 * 10 Fecha Igual o anterior a
                 * 11 Fecha Igual o poserterir a 
                 * 12 Numero igual que
                 * 13 Numero igual o mayor que
                 * 14 Numero igual o menor que
                 * 15 Disponible solo si
                 * 16 Obligatoria solo si
                 */
                //?Validar el tipo de dato de la respuesta para filtrar los tipos de validaciones posibles
                //!Tipo dato 1 (Numero)
                if(tipoDatoId===1){
                    //!Las validaciones son 4,5,6,12,13,14,15,16
                    arrFiltro = [4,5,6,12,13,14,15,16];
                }
                //!Tipo dato 2 (Moneda)
                if(tipoDatoId===2){
                    //!Las validaciones son 4,5,6,12,13,14,15,16
                     arrFiltro = [4,5,6,12,13,14,15,16];
                }
                //!Tipo dato 3 (Sumatoria)
                if(tipoDatoId===3){
                    //!Las validaciones son numero igual o mayor que
                    arrFiltro = [4,5,12,13,14];
                }
                //!Tipo dato 4 (Texto)
                if(tipoDatoId===4){
                    //!Las validaciones son 1,6,15,16
                     arrFiltro = [1,6,15,16];
                }
                //!Tipo dato 5 (Fecha)
                if(tipoDatoId===5){
                    //!Las validaciones son 2,6,9,10,11,15,16
                    arrFiltro = [2,6,9,10,11,15,16];
                }
                //!Tipo dato 6 (SI/NO)
                if(tipoDatoId===6){
                    //!Las validaciones son 6, 15, 16
                    arrFiltro = [6, 15, 16];
                }
                //!Tipo dato 7 (Elemento de una lista (Lista desplegable))
                if(tipoDatoId===7){
                    //!Las validaciones son 6, 15, 16
                    arrFiltro = [6, 15, 16];
                }

                //!Definir las validaciones disponibles para el tipo de elemento
                this.validacionesDisponibles = this.validaciones.filter(function(el) { return arrFiltro.includes(el.id) } ); 
                //console.log(filtered)
                /* Validaciones para el tipo de dato recibido */

                this.tableLoadingValidaciones=false;
            })
            .catch(()=>{
                this.tableLoadingValidaciones=false;
            })
            
        },

        //!Obtener los datos de la respuesta para actualizar
        async obtenerDatosRespuesta(Id){
            this.dialogLoaderRespuestaVisible=true;
            this.datosRespuesta.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Respuesta';
            this.btnRegistroText='Actualizar Respuesta';
            this.activeTab=0;
            await this.$store
                .dispatch(OBTENER_RESPUESTA, Id)
                .then(res => {
                    if(res.status===200){
                        this.datosRespuesta = this.$store.state.respuesta.respuesta;
                        this.datosRespuesta.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.tipoListas=false;
                        if(this.datosRespuesta.listasId!=null){
                            this.tipoListas=true;
                        } 
                        this.dialogRes = true; 
                            
                    } else{
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderRespuestaVisible = false;
                })
                .catch(err => {
                    this.dialogLoaderRespuestaVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido en el proceso, por favor, ponte en contacto con un administrador del sistema. REF: ${err}`);
                });
        },

        //!Se lanza cuando se hace click en una fila de la tabla de respuestas
        respuestasRowClick(row){
            this.respuestaSeleccionada=row.id;
            //console.log(this.respuestaSeleccionada)
            this.selectedItem = row;
            this.textoRespuestaActual = row.textoRespuesta;
            this.datosValidacion.respuestasId = row.id;
            this.tipoDatoIdRespuestaSeleccionada = row.tipoDatoId;
            this.obtenerValidacionesRespuesta(row.id, row.tipoDatoId);
        },

        //!Mostrar modal para la nueva respuesta
        modalNuevaRespuesta(){
            this.dialogRes=true;
        },

        //!Mostrar el modal para una nueva valiacion 
        modalNuevaValidacion(){
            this.dialogVal=true;
        },

        //!Mostrar modal para seleccionar la validacion a partir de otra respueta
        mostrarValoresRespuestas(){
            this.$refs.validacionesPorRespuesta.obtenerIndices();
        },

        //!Asignar el valor obtenido de la respuesta seleccionada.
        setValorPorRespuesta(valor){
            console.log(valor)
        },


        //!Seleccionar el tipo de elemento en función del tipo de dato
        seleccionarTipoElemento(){
            if(this.datosRespuesta.tipoDatoId===1 || this.datosRespuesta.tipoDatoId===2 || this.datosRespuesta.tipoDatoId===3)
                this.datosRespuesta.tipoElementoId = 1;
            else if(this.datosRespuesta.tipoDatoId===4)
                this.datosRespuesta.tipoElementoId =2;
            else if(this.datosRespuesta.tipoDatoId===5)
                this.datosRespuesta.tipoElementoId = 4;
            else if(this.datosRespuesta.tipoDatoId===6 || this.datosRespuesta.tipoDatoId===7)
                this.datosRespuesta.tipoElementoId = 3;

            this.tipoListas=false;
            //?Si el tipo de dato es elemento de una lista (7) mostrar las listas
            if(this.datosRespuesta.tipoDatoId===7){
                this.tipoListas = true;
            }

                //console.log(this.datosRespuesta.tipoDatoId)
        },


        //!Obtener Indices
        async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                    this.dialog=true;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });

        },

        //!Obtener todas las preguntas por indice
        async obtenerPreguntasPorIndice(){
            //console.log(this.indiceSeleccionadoId);
            this.ddPreguntasLoading=true;
            this.preguntas=[];
            await this.$store
            .dispatch(OBTENER_TODAS_PREGUNTAS_POR_INDICE, this.indiceSeleccionadoId)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.preguntas = res.data;
                } else {
                    //console.warn(res.message)
                    let message=`Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema`;
                    if(res.message){
                        message = res.message;
                    }
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', message);
                }
                this.ddPreguntasLoading=false;
            })
            .catch(() => {
                this.ddPreguntasLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });
        },


        //!Obtener las respuestas por pregunta y tipo de dato 6 seleccionada
        async obtenerRespuestasPorPregunta(preguntaId){
            
            //!Definir el tipo de dato de las respuestas que se van a ir a obtener, en base al tipo de validacion que se seleccionó
            console.log(this.datosValidacion.validacionesId)
            let tipoDatoId=0;
            if(this.datosValidacion.validacionesId===4 || this.datosValidacion.validacionesId===5 || this.datosValidacion.validacionesId===8 || this.datosValidacion.validacionesId===12 || this.datosValidacion.validacionesId===13 || this.datosValidacion.validacionesId===14){
                tipoDatoId = 1;
            }
            if(this.datosValidacion.validacionesId===2 || this.datosValidacion.validacionesId===3 || this.datosValidacion.validacionesId===10 || this.datosValidacion.validacionesId===11){
                tipoDatoId = 5;
            }

            if(this.datosValidacion.validacionesId===2 || this.datosValidacion.validacionesId===3 || this.datosValidacion.validacionesId===10 || this.datosValidacion.validacionesId===11){
                tipoDatoId = 5;
            }

            if(this.datosValidacion.validacionesId===15 || this.datosValidacion.validacionesId===16){
                tipoDatoId = 6;
            }
            
            this.respuestasValidacion=[];
            this.ddRespuestasLoading=true;
            await 
            this.$store.dispatch(OBTENER_RESPUESTAS_PREGUNTA_TIPODATO,{preguntasId: preguntaId, tipoDatoId: tipoDatoId})
            .then(response => {
                //console.log(response)
                if(response.status==200){
                    this.respuestasValidacion=response.data;
                } else{
                    this.respuestasValidacion=[];
                }   
                this.ddRespuestasLoading=false;
            })
            .catch(err=>{
                console.log(err)
                this.ddRespuestasLoading=false;
            })
        },


        //!Definir orígenes de la Validación
        definirOrigenesValidacion(){

            if(this.datosValidacion.validacionesId===15 || this.datosValidacion.validacionesId===16){
                this.origenesRespuesta=[{id:0, nombreOrigen:'Seleccionar'}, {id:2, nombreOrigen: 'Valor de otra respuesta'}];
            } else {
               this.origenesRespuesta=[{id:0, nombreOrigen:'Seleccionar'},{id: 1, nombreOrigen: 'Definido por el usuario'}, {id:2, nombreOrigen: 'Valor de otra respuesta'}];
            }
             

        },


        //!Registrar validaciones respuesta
        async registrarValidacionRespuesta(){

            if(this.datosValidacion.validacionesId != 7 && this.datosValidacion.validacionesId != 8){
                delete this.datosValidacion.rangosId; 
            }

            //!Quitar la probiedad respuestaIdValorSeleccionado si el origen es "definido por el usuario"
            if(this.datosValidacion.tipoValorInicial ===1){
                delete this.datosValidacion.respuestaIdValorSeleccionado;
            } else if(this.datosValidacion.tipoValorInicial == 2 && (this.datosValidacion.validacionesId===15 || this.datosValidacion.validacionesId===16)){
                delete this.datosValidacion.valorDefinido;
            }


            this.datosValidacion.respuestasId = this.respuestaSeleccionada;
            this.switchItemEstado ? this.datosValidacion.estadosId = 1 : this.datosValidacion.estadosId = 2;
            this.btnRegistroValidacionLoading=true;

            //!En base al tipo de validación, definir el Campo ValorDefinido
            // 6 Obligatoria
            if(this.datosValidacion.validacionesId===6){
               // console.log("3")
                this.datosValidacion.valorDefinido = this.opcionSiNoId;
            }
            else if(this.datosValidacion.validacionesId===2 || this.datosValidacion.validacionesId===3 || this.datosValidacion.validacionesId===4 
                 || this.datosValidacion.validacionesId===5 || this.datosValidacion.validacionesId===7 || this.datosValidacion.validacionesId===8 
                 || this.datosValidacion.validacionesId ===4 || this.datosValidacion.validacionesId===5 || this.datosValidacion.validacionesId ===12 || this.datosValidacion.validacionesId===13 || this.datosValidacion.validacionesId ===14){
                //?Validar si la validación es definida por el usuario
                if(this.datosValidacion.tipoValorInicial===1){
                   this.datosValidacion.valorDefinido = this.valorInicialUsuario;
                }

                //?Validar si la validación es a través del valor de una respuesta
                /*else if(this.datosValidacion.origenValidacion===2){

                }*/
            }
            console.log(this.datosValidacion.validacionesId);
            //!Si la respuestas es obligatoria si/no agregar el tipo valor inicial como 1
            if(this.datosValidacion.validacionesId===6){
                this.datosValidacion.tipoValorInicial =1;
                this.datosValidacion.valorDefinido = this.opcionSiNoId.toString();
            }

            if(this.tipoRespuestaId){
                this.datosvalid.tipoRespuestaId = this.datosValidacion.tipoValorInicial;
            }


            //! Si el tipo de validacion es 15 Disponible solo si o 16 obligatoria solo si, almacenar el valor en el campo valorDefinido
            if(this.datosValidacion.validacionesId===15 || this.datosValidacion.validacionesId===16){

                this.datosValidacion.valorDefinido = this.opcionSiNoId.toString();
            }
    
            if(this.accionVal===1){
                await this.$store
                    .dispatch(REGISTRAR_VALIDACION_RESPUESTA, {datosItem: this.datosValidacion, tipoValorInicial: this.tipoValorInicial, tipoValorFinal: this.tipoValorFinal})
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerValidacionesRespuesta(this.datosValidacion.respuestasId);
                            this.dialogVal=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetValForm();                                
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroValidacionLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroValidacionLoading=false;
                    });
            } else {
                await this.$store
                    .dispatch(ACTUALIZAR_RESPUESTA, this.datosValidacion)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerValidacionesRespuesta(this.datosValidacion.respuestasId);
                            this.dialogVal=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetValForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroValidacionLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroValidacionLoading=false;
                    });
            }
        },


        //!Cambiar el estado de la validacion
        async deshabilitarValidacion(IdValidacion, NuevoEstado, respuestasId){
            
            
            this.dialogLoaderRespuestaVisible = true;


            this.datosValidacion = {
                id: IdValidacion,
                estadosId: NuevoEstado,
                valorDefinido:'',
                validacionesId:1,
                respuestasId:respuestasId,
                respuestaIdValorSeleccionado:1,
                valorInicial:'',
                valorFinal: '',
                respuestasIdValorInicial: 1,
                respuestasIdValorFinal: 1

            }
            await this.$store
            .dispatch(ACTUALIZAR_ESTADO_VALIDACION_RESPUESTA, this.datosValidacion)
            .then(res => {
                if(res.status===200){
                    this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                    this.obtenerValidacionesRespuesta(this.datosValidacion.respuestasId);
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', res.message);
                }
                this.dialogLoaderRespuestaVisible = false;
            })
            .catch(error => {
                //console.log(error)
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                this.dialogLoaderRespuestaVisible = false;
            });

            
        },
    },
    created(){
        
        this.obtenerRespuestasPregunta();
        this.obtenerValidaciones();
        this.obtenerTipoDatoPregunta();
        this.obtenerTipoElementoPregunta();
        this.obtenerListasPregunta();
        this.obtenerIndices();
    },
    computed: {
        respuestasHeaders() {
            return [
               /* {
                    text: "Ordenar",
                    align: "start",
                    sortable: false,
                    value: ""
                },*/
                {
                    text: "No. Orden",
                    align: "start",
                    sortable: false,
                    value: "noOrden"
                },
                /*{
                    text: "Id",
                    align: "start",
                    sortable: false,
                    value: "id"
                },*/
                {
                    text: "Texto Respuesta",
                    value: "textoRespuesta",
                    sortable: false,
                },
                {
                    text: "Tipo de dato",
                    value: "nombreTipoDato",
                    sortable: false,
                },
                {
                    text: "Estado",
                    value: "estadosId",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "actions",
                    sortable: false,
                }
            ]
        },
        validacionesHeaders(){
             return [
                 
                {
                    text: "Id",
                    align: "start",
                    sortable: false,
                    value: "id"
                },
                {
                    text: "Tipo de Validación",
                    value: "nombre",
                    sortable: false,
                },
                {
                    text: "Definición",
                    value: "valorDefinido",
                    sortable: false,
                },
                 {
                    text: "Estado",
                    value: "estadosId",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "actions",
                    sortable: false,
                }
            ]
        }
    }
}
</script>

<style lang="scss">

.selectedRow {
    background-color: #eeeeee;
    border-left: 4px solid #009688;
}

.hoverRow:hover{
    cursor: pointer;
}
</style>